var _style, _rect, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _path6, _defs, _g4, _g5, _path7, _defs2, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _ellipse, _circle, _circle2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatedSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4149.8 3142",
    style: {
      enableBackground: "new 0 0 4149.8 3142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#FFFFFF;}\n\t.st1{fill:#FFD7BE;}\n\t.st2{fill:#92ADEA;}\n\t.st3{fill:#AFC3F0;}\n\t.st4{fill:#161310;}\n\t.st5{fill:#545454;}\n\t.st6{fill:#2057D5;}\n\t.st7{fill:#8BA8E9;}\n\t.st8{fill:#3F6FDB;}\n\t.st9{fill:#B5C8F1;}\n\t.st10{fill:#E9EEFB;}\n\t.st11{fill:#FF9F00;}\n\t.st12{clip-path:url(#SVGID_00000163759212408624461120000018364494420514677945_);fill:#E95900;}\n\t.st13{clip-path:url(#SVGID_00000163759212408624461120000018364494420514677945_);}\n\t.st14{fill:#E95900;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:#F8FAFE;}\n\t.st17{fill:#D7E1F7;}\n\t.st18{clip-path:url(#SVGID_00000016049971811247957420000014040585728452951944_);}\n\t.st19{fill:#63A5A2;}\n\t.st20{fill:#498981;}\n\t.st21{fill:#4D7772;}\n\t.st22{fill:#537EDF;}\n\t.st23{fill:#7B9CE6;}\n\t.st24{fill:#7395E5;}\n\t.st25{fill:#98B2EC;}\n\t.st26{fill:#658BE2;}\n\t.st27{fill:#DEE6F9;}\n\t.st28{fill:#94AEEB;}\n\t.st29{fill:#6389E2;}\n\t.st30{fill:#678DE2;}\n\t.st31{fill:#F19A6D;}\n\t.st32{fill:#141F35;}\n\t.st33{fill:#C17656;}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_x30_1_1_",
    x: -912,
    y: -564.9,
    className: "st0",
    width: 5973.9,
    height: 3982.6
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2877.5,307.2C2219.8-159,1299.3,108.5,1000.2,857c-24.5,61.2-46,126.9-64.1,197.5 c0,0-333.4,75.9-633.5,664.8c0,0-700.4,1284.2,1255.4,1228.2c2035.2-58.3,2797.3-658.4,1996.6-1832.4 C3554.6,1115.2,3326.2,625.2,2877.5,307.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2758.4,1024.4c0-287.9-233.4-521.2-521.2-521.2c-24.6,0-48.9,1.7-72.6,5c-94.1-87-207.1-153.2-331.9-191.6 l-1.5-37.6h-249.6c-422.1,0-773.9,307-852,713.8c-244.6,85.3-420.1,317.9-420.1,591.6c0,128.6,38.8,248.1,105.2,347.6h2445.3 v-768.3h-120.4C2751.8,1119.3,2758.4,1072.6,2758.4,1024.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2975.4,1025.4c0-287.9-233.4-521.2-521.2-521.2c-24.6,0-48.9,1.7-72.6,5 c-154.1-142.4-358.6-229.2-583-229.2c-422.1,0-773.9,307-852,713.8c-244.6,85.3-420.1,317.9-420.1,591.6 c0,128.6,38.8,248.1,105.2,347.6h2445.3v-768.3h-120.4C2968.8,1120.3,2975.4,1073.7,2975.4,1025.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2563.3,687h-958.6c-58.1,0-105.1,47.1-105.1,105.1v919.4c0,58.1,47.1,105.1,105.1,105.1h958.6 c58.1,0,105.1-47.1,105.1-105.1V792.1C2668.5,734.1,2621.4,687,2563.3,687z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2454.6,687h-849.9c-58.1,0-105.1,47.1-105.1,105.1v919.4c0,58.1,47.1,105.1,105.1,105.1h849.9 c58.1,0,105.1-47.1,105.1-105.1V792.1C2559.7,734.1,2512.7,687,2454.6,687z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1460.3,
    y: 846.8,
    className: "st6",
    width: 35,
    height: 88.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1477.8,783.5c-1.4,0-2.8,0.1-4.1,0.4c-10.1,1.9-17.7,10.8-17.7,21.4v88.5h43.6v-88.5 c0-6-2.4-11.5-6.4-15.4C1489.2,786,1483.8,783.5,1477.8,783.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1456,999.2c0,6,2.4,11.5,6.4,15.4c3,3,6.9,5.2,11.3,6c1.3,0.3,2.7,0.4,4.1,0.4c12,0,21.8-9.8,21.8-21.8 v-88.4H1456V999.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1456,893.8 1460.3,893.8 1460.3,910.8 1456,910.8 1456,935.3 1487,935.3 1487,846.8 1456,846.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1473.7,783.9c-10.1,1.9-17.7,10.8-17.7,21.4v88.5h35.3v-88.5c0-6-2.4-11.5-6.4-15.4 C1481.9,786.9,1478,784.8,1473.7,783.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1456,999.2c0,6,2.4,11.5,6.4,15.4c3,3,6.9,5.2,11.3,6c10.1-1.9,17.7-10.8,17.7-21.4v-88.4H1456V999.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1460.3,
    y: 1481.2,
    className: "st6",
    width: 35,
    height: 88.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1477.8,1417.9c-1.4,0-2.8,0.1-4.1,0.4c-10.1,1.9-17.7,10.8-17.7,21.4v88.5h43.6v-88.5 c0-6-2.4-11.5-6.4-15.4C1489.2,1420.3,1483.8,1417.9,1477.8,1417.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1456,1633.6c0,6,2.4,11.5,6.4,15.4c3,3,6.9,5.2,11.3,6c1.3,0.3,2.7,0.4,4.1,0.4c12,0,21.8-9.8,21.8-21.8 v-88.4H1456V1633.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1456,1528.1 1460.3,1528.1 1460.3,1545.1 1456,1545.1 1456,1569.7 1487,1569.7 1487,1481.2  1456,1481.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1473.7,1418.2c-10.1,1.9-17.7,10.8-17.7,21.4v88.5h35.3v-88.5c0-6-2.4-11.5-6.4-15.4 C1481.9,1421.2,1478,1419.1,1473.7,1418.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1456,1633.6c0,6,2.4,11.5,6.4,15.4c3,3,6.9,5.2,11.3,6c10.1-1.9,17.7-10.8,17.7-21.4v-88.4H1456V1633.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1249.6,687H504.3c-45.1,0-81.7,47.1-81.7,105.1v919.4c0,58.1,36.6,105.1,81.7,105.1h745.3 c45.1,0,81.7-47.1,81.7-105.1V792.1C1331.4,734.1,1294.8,687,1249.6,687z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1374.3,687H628.9c-45.1,0-81.7,47.1-81.7,105.1v919.4c0,58.1,36.6,105.1,81.7,105.1h745.3 c45.1,0,81.7-47.1,81.7-105.1V792.1C1456,734.1,1419.4,687,1374.3,687z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1374.3,1779.6H628.9c-23.8,0-44.7-31.8-44.7-68.1V792.1c0-36.3,20.9-68.1,44.7-68.1h745.3 c23.8,0,44.7,31.8,44.7,68.1v919.4C1419,1747.8,1398.1,1779.6,1374.3,1779.6z M628.9,739.3c-11.7,0-29.4,21.1-29.4,52.8v919.4 c0,31.7,17.7,52.8,29.4,52.8h745.3c11.7,0,29.4-21.1,29.4-52.8V792.1c0-31.7-17.7-52.8-29.4-52.8H628.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1350.8,776.3H652.4c-8.6,0-15.8,6.9-15.8,15.5v919.8c0,8.6,7.2,15.5,15.8,15.5h698.4 c8.6,0,15.8-6.9,15.8-15.5V791.9C1366.6,783.3,1359.4,776.3,1350.8,776.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1261.4,776.3H652.4c-8.6,0-15.8,6.9-15.8,15.5v919.8c0,8.6,7.2,15.5,15.8,15.5h609.1 c8.6,0,15.8-6.9,15.8-15.5V791.9C1277.3,783.3,1270.1,776.3,1261.4,776.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M971.6,1105.4c-76.8,0-139.1,62.3-139.1,139.1s62.3,139.1,139.1,139.1c76.8,0,139.1-62.3,139.1-139.1 c0-1.9,0-3.9-0.1-5.8C1107.6,1164.6,1046.5,1105.4,971.6,1105.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -587.3918 1071.0363)",
    className: "st9",
    cx: 999.2,
    cy: 1244.6,
    rx: 139.1,
    ry: 139.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1355.6,1217.2H647.5c-6.1,0-11,4.9-11,11v25.9c0,6.1,4.9,11,11,11h708.1c6.1,0,11-4.9,11-11v-25.9 C1366.6,1222.1,1361.7,1217.2,1355.6,1217.2z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2534.4,1593.8h-319.9v-117.7c0-14-11.4-25.4-25.4-25.4h-280.5v-267.9c0-14-11.4-25.4-25.4-25.4h-383.6 v554.1c0,58.1,47.1,105.1,105.1,105.1h849.9c58.1,0,105.1-47.1,105.1-105.1v-92.3C2559.7,1605.2,2548.4,1593.8,2534.4,1593.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2559.7,792.1v919.4c0,58.1-47.1,105.1-105.1,105.1h-849.9c-58.1,0-105.1-47.1-105.1-105.1V792.1 c0-58.1,47.1-105.1,105.1-105.1h849.9C2512.7,687,2559.7,734.1,2559.7,792.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158720769282447290670000003830841490765374894_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158720769282447290670000003830841490765374894_)",
      fill: "#E95900"
    },
    d: "M1970.5,1207.6 v750.2h604.3v-810.1h-544.3C1997.3,1147.6,1970.5,1174.5,1970.5,1207.6z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158720769282447290670000003830841490765374894_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2112.3,1467.4H1809l-31.2-36.3c-3-3.5-7.3-5.5-11.9-5.5h-80.1h-80.1c-4.6,0-8.9,2-11.9,5.5l-31.2,36.3 h-19.6c-21.1,0-38.1,17.1-38.1,38.1V1821c0,21.1,17.1,38.1,38.1,38.1h569.3c21.1,0,38.1-17.1,38.1-38.1v-315.5 C2150.5,1484.4,2133.4,1467.4,2112.3,1467.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2196.5,1467.4h-303.3l-31.2-36.3c-3-3.5-7.3-5.5-11.9-5.5H1770h-80.1c-4.6,0-8.9,2-11.9,5.5 l-31.2,36.3h-19.6c-21.1,0-38.1,17.1-38.1,38.1V1821c0,21.1,17.1,38.1,38.1,38.1h569.3c21.1,0,38.1-17.1,38.1-38.1v-315.5 C2234.6,1484.4,2217.6,1467.4,2196.5,1467.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2196.5,1845.4h-569.3c-13.5,0-24.5-11-24.5-24.5v-315.5c0-13.5,11-24.5,24.5-24.5h15.3 c6.7,0,13-2.9,17.3-8l28.7-33.4l0.8-0.4l0.5,0h160.6l0.8,0.4l0.3,0.4l28.4,33.1c4.3,5.1,10.7,8,17.3,8h299.1 c13.5,0,24.5,11,24.5,24.5V1821C2221,1834.5,2210,1845.4,2196.5,1845.4z M1627.2,1485c-11.3,0-20.6,9.2-20.6,20.6V1821 c0,11.3,9.2,20.6,20.6,20.6h569.3c11.3,0,20.6-9.2,20.6-20.6v-315.5c0-11.3-9.2-20.6-20.6-20.6h-299.1 c-7.8,0-15.2-3.4-20.3-9.3l-27.9-32.4h-158.5l-27.9,32.4c-5.1,5.9-12.5,9.3-20.3,9.3H1627.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2229.3,1609.1h-611.8v117.7h611.8c11.2,0,20.3-9.1,20.3-20.3v-77 C2249.6,1618.2,2240.5,1609.1,2229.3,1609.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1488.8,1622.1v91.8c0,7.1,5.8,12.9,12.9,12.9h115.7v-117.7h-115.7 C1494.6,1609.1,1488.8,1614.9,1488.8,1622.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1862.5,1507.1h-219.2c-6.6,0-11.9,5.3-11.9,11.9v65.4c0,6.6,5.3,11.9,11.9,11.9h219.2 c6.6,0,11.9-5.3,11.9-11.9V1519C1874.4,1512.4,1869.1,1507.1,1862.5,1507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1862.5,1507.1h-14.2c6.6,0,11.9,5.3,11.9,11.9v65.4c0,6.6-5.3,11.9-11.9,11.9h14.2 c6.6,0,11.9-5.3,11.9-11.9V1519C1874.4,1512.4,1869.1,1507.1,1862.5,1507.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1681,1528.5h-13.4c-3.7,0-5.6,1.9-5.6,5.6v37.3c0,3.7,1.9,5.6,5.6,5.6h13.4c8.2,0,14.6-2.1,19.1-6.3 c4.5-4.2,6.8-10.2,6.8-17.9c0-7.7-2.3-13.7-6.8-17.9C1695.7,1530.6,1689.3,1528.5,1681,1528.5z M1680.4,1568.2h-7.7v-30.9 h7.7c10.3,0,15.4,5.1,15.4,15.4C1695.9,1563,1690.7,1568.2,1680.4,1568.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1741.1,1532.3c-0.7-1.6-1.5-2.7-2.5-3.4c-1-0.7-2.2-1.1-3.5-1.1c-1.3,0-2.5,0.4-3.5,1.1 c-1,0.7-1.9,1.8-2.6,3.4l-17.6,38.5c-0.9,1.9-0.9,3.5-0.1,4.7c0.8,1.3,2.2,1.9,4.1,1.9c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.5-1.9,2.2-3.5l2.8-6.6h22.6l2.9,6.6c0.6,1.6,1.4,2.7,2.2,3.4c0.8,0.7,2,1.1,3.6,1.1c1.8,0,3.1-0.6,3.9-1.9 c0.8-1.3,0.8-2.8-0.1-4.8L1741.1,1532.3z M1727.3,1558.1l7.6-18.3h0.1l7.8,18.3H1727.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1794.6,1528.5h-34.9c-3,0-4.5,1.5-4.5,4.4c0,2.9,1.5,4.4,4.5,4.4h12.1v34.7c0,1.7,0.5,3.1,1.4,4 c0.9,1,2.2,1.4,4,1.4c1.7,0,3.1-0.5,3.9-1.4c0.9-1,1.3-2.3,1.3-4v-34.7h12.1c3,0,4.5-1.5,4.5-4.4 C1799.1,1530,1797.6,1528.5,1794.6,1528.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1825.3,1532.3c-0.7-1.6-1.5-2.7-2.5-3.4c-1-0.7-2.2-1.1-3.5-1.1c-1.3,0-2.5,0.4-3.5,1.1 c-1,0.7-1.9,1.8-2.6,3.4l-17.6,38.5c-0.9,1.9-0.9,3.5-0.1,4.7c0.8,1.3,2.2,1.9,4.1,1.9c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.5-1.9,2.2-3.5l2.8-6.6h22.6l2.9,6.6c0.6,1.6,1.4,2.7,2.2,3.4c0.8,0.7,2,1.1,3.6,1.1c1.8,0,3.1-0.6,3.9-1.9 c0.8-1.3,0.8-2.8-0.1-4.8L1825.3,1532.3z M1811.5,1558.1l7.6-18.3h0.1l7.8,18.3H1811.5z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2297.3,1465.5h-303.3l-31.2-36.3c-3-3.5-7.3-5.5-11.9-5.5h-80.1h-80.1c-4.6,0-8.9,2-11.9,5.5 l-31.2,36.3H1728c-21.1,0-38.1,17.1-38.1,38.1v315.5c0,21.1,17.1,38.1,38.1,38.1h569.3c21.1,0,38.1-17.1,38.1-38.1v-315.5 C2335.4,1482.5,2318.3,1465.5,2297.3,1465.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2381.4,1465.5h-303.3l-31.2-36.3c-3-3.5-7.3-5.5-11.9-5.5h-80.1h-80.1c-4.6,0-8.9,2-11.9,5.5 l-31.2,36.3h-19.6c-21.1,0-38.1,17.1-38.1,38.1v315.5c0,21.1,17.1,38.1,38.1,38.1h569.3c21.1,0,38.1-17.1,38.1-38.1v-315.5 C2419.6,1482.5,2402.5,1465.5,2381.4,1465.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2381.4,1843.5h-569.3c-13.5,0-24.5-11-24.5-24.5v-315.5c0-13.5,11-24.5,24.5-24.5h15.3 c6.7,0,13-2.9,17.3-8l28.7-33.4l0.8-0.4l0.5,0h160.6l0.8,0.4l0.3,0.4l28.4,33.1c4.3,5.1,10.7,8,17.3,8h299.1 c13.5,0,24.5,11,24.5,24.5v315.5C2405.9,1832.6,2394.9,1843.5,2381.4,1843.5z M1812.2,1483.1c-11.3,0-20.6,9.2-20.6,20.6 v315.5c0,11.3,9.2,20.6,20.6,20.6h569.3c11.3,0,20.6-9.2,20.6-20.6v-315.5c0-11.3-9.2-20.6-20.6-20.6h-299.1 c-7.8,0-15.2-3.4-20.3-9.3l-27.9-32.4h-158.5l-27.9,32.4c-5.1,5.9-12.5,9.3-20.3,9.3H1812.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2414.2,1607.2h-611.8v117.7h611.8c11.2,0,20.3-9.1,20.3-20.3v-77 C2434.5,1616.3,2425.4,1607.2,2414.2,1607.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1673.8,1620.2v91.8c0,7.1,5.8,12.9,12.9,12.9h115.7v-117.7h-115.7 C1679.6,1607.2,1673.8,1613,1673.8,1620.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2047.4,1505.2h-219.2c-6.6,0-11.9,5.3-11.9,11.9v65.4c0,6.6,5.3,11.9,11.9,11.9h219.2 c6.6,0,11.9-5.3,11.9-11.9v-65.4C2059.3,1510.5,2054,1505.2,2047.4,1505.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2047.4,1505.2h-14.2c6.6,0,11.9,5.3,11.9,11.9v65.4c0,6.6-5.3,11.9-11.9,11.9h14.2 c6.6,0,11.9-5.3,11.9-11.9v-65.4C2059.3,1510.5,2054,1505.2,2047.4,1505.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1866,1526.6h-13.4c-3.7,0-5.6,1.9-5.6,5.6v37.3c0,3.7,1.9,5.6,5.6,5.6h13.4c8.2,0,14.6-2.1,19.1-6.3 c4.5-4.2,6.8-10.2,6.8-17.9c0-7.7-2.3-13.7-6.8-17.9C1880.6,1528.7,1874.2,1526.6,1866,1526.6z M1865.4,1566.3h-7.7v-30.9 h7.7c10.3,0,15.4,5.1,15.4,15.4C1880.8,1561.1,1875.6,1566.3,1865.4,1566.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1926,1530.4c-0.7-1.6-1.5-2.7-2.5-3.4c-1-0.7-2.2-1.1-3.5-1.1c-1.3,0-2.5,0.4-3.5,1.1 c-1,0.7-1.9,1.8-2.6,3.4l-17.6,38.5c-0.9,1.9-0.9,3.5-0.1,4.7c0.8,1.3,2.2,1.9,4.1,1.9c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.5-1.9,2.2-3.5l2.8-6.6h22.6l2.9,6.6c0.6,1.6,1.4,2.7,2.2,3.4c0.8,0.7,2,1.1,3.6,1.1c1.8,0,3.1-0.6,3.9-1.9 c0.8-1.3,0.8-2.8-0.1-4.8L1926,1530.4z M1912.2,1556.2l7.6-18.3h0.1l7.8,18.3H1912.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1979.5,1526.6h-34.9c-3,0-4.5,1.5-4.5,4.4c0,2.9,1.5,4.4,4.5,4.4h12.1v34.7c0,1.7,0.5,3.1,1.4,4 c0.9,1,2.2,1.4,4,1.4c1.7,0,3.1-0.5,3.9-1.4c0.9-1,1.3-2.3,1.3-4v-34.7h12.1c3,0,4.5-1.5,4.5-4.4 C1984,1528.1,1982.5,1526.6,1979.5,1526.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2010.2,1530.4c-0.7-1.6-1.5-2.7-2.5-3.4c-1-0.7-2.2-1.1-3.5-1.1c-1.3,0-2.5,0.4-3.5,1.1 c-1,0.7-1.9,1.8-2.6,3.4l-17.6,38.5c-0.9,1.9-0.9,3.5-0.1,4.7c0.8,1.3,2.2,1.9,4.1,1.9c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.5-1.9,2.2-3.5l2.8-6.6h22.6l2.9,6.6c0.6,1.6,1.4,2.7,2.2,3.4c0.8,0.7,2,1.1,3.6,1.1c1.8,0,3.1-0.6,3.9-1.9 c0.8-1.3,0.8-2.8-0.1-4.8L2010.2,1530.4z M1996.4,1556.2l7.6-18.3h0.1l7.8,18.3H1996.4z"
  })))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2054,376.2c-404.2-117.6-677,72.3-782.9,168c-6.1,5.5,1.2,15.1,8.1,10.7 c308.7-197.6,617.1-188.2,771.9-165.5C2059.4,390.6,2062.1,378.6,2054,376.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052818812323327652820000004708416434704119726_",
    d: "M302.6,1719.4c0,0-700.4,1284.2,1255.4,1228.2 c2035.2-58.3,2797.3-658.4,1996.6-1832.4c0,0-228.4-490-677.1-808.1C2219.8-159,1299.3,108.5,1000.2,857 c-24.5,61.2-46,126.9-64.1,197.5C936.2,1054.5,602.8,1130.4,302.6,1719.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091001250587350180080000000591350891734165402_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052818812323327652820000004708416434704119726_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091001250587350180080000000591350891734165402_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M802.2,1733.6c-43.9-146.4-73.1-239.9-75.2-271.7c0,0-52.7,135-83.5,211.6 c-68,169-84.4,300.5-14,439.2c0,0,0.4,75.8,1,79.1c0.6,3.3,78,77.2,78,77.2l116.4-71.7L817,2071 C817,2071,846.1,1880,802.2,1733.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M677,2272.9l62.7,20c0,0,21.8-405.1-8-642.3C731.7,1650.5,733.1,2076.4,677,2272.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M757.6,2271.3c0,0-109.3-297.2-375-373.6l-0.1,0c-86.1-24.8-188.5-26.3-308.9,12.9 c0,0,148-41.1,229.9,119.2c3,5.8,5.9,11.9,8.7,18.3c79.7,181.7,184.2,283,250.9,309.1c40.5,15.8,90.6,56.6,123.7,86.2 c21.5,19.2,35.8,33.7,35.8,33.7l35.7-5.9l-0.4-105.2L757.6,2271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M289,1913.2c4.8,1.8,156.9,60.3,397.9,530.3c21.5,19.2,35.8,33.7,35.8,33.7l35.7-5.9l-0.4-105.2 C697.6,2256.1,519.4,1966.8,289,1913.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M885.6,1887.1L885.6,1887.1c-223.8,137.9-248,438-248,438l23.9,86.9l26.5,96.5l34.2-3.7 c0,0,9.4-16.9,24.2-40.1c22.8-35.6,58.2-85.7,91.3-110.6c54.5-41,124.3-160.5,150.9-347.2c1-6.6,2-12.9,3.3-19 c34-167.8,180.1-167.9,180.1-167.9C1051.5,1814.9,958.1,1842.4,885.6,1887.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M661.4,2412l26.5,96.5l34.2-3.7c0,0,9.4-16.9,24.2-40.1c100.7-492.1,225-584.6,228.9-587.4 C777.9,1985.4,688.6,2295.9,661.4,2412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M664.9,2373.4c-64.9-64.9-172.5-135.5-304.5-81.7C183.7,2363.8,146,2576.8,138,2657.2 c-1,9.9,11.2,15.4,18,8c67-73.8,291.6-293.6,523-204.6c8.6,3.3,17.3,7,25.9,11.2c3.1,1.5,6.3,2.5,9.7,2.8 c5.1,0.4,11.8-0.4,15.3-6.8c2.8-5.1,2.2-11.3-1-16.2C720.8,2439.3,698.6,2407.1,664.9,2373.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M233.3,2480.4c16.7-22.7,202.5-250.5,445.7-19.7c8.6,3.3,17.3,7,25.9,11.2c3.1,1.5,6.3,2.5,9.7,2.8 c5.1,0.4,11.8-0.4,15.3-6.8c2.8-5.1,2.2-11.3-1-16.2C728.9,2451.7,464.5,2159.1,233.3,2480.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M233.3,2480.4c-0.2,0.2-0.4,0.5-0.5,0.7C232.9,2480.8,233.1,2480.6,233.3,2480.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M232.3,2481.6c-0.1,0.2-0.2,0.3-0.3,0.4C232.2,2481.9,232.2,2481.7,232.3,2481.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M232.3,2481.6c0.1-0.2,0.3-0.4,0.4-0.6C232.6,2481.2,232.5,2481.4,232.3,2481.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M972.6,2153.6c-153.7,17.5-219.3,140.8-247.3,236.4c-14.5,49.7-18.9,92-20.1,108 c-0.4,6.2,2.2,12.5,7.5,15.9c6.7,4.2,13.4,1.6,18.1-1.5c3.1-2,5.6-4.7,7.8-7.7c6-8.5,12.3-16.6,18.8-24.2 c173.8-205.3,502.3-113.2,604.5-77.8c10.3,3.5,19-8.1,12.9-17C1325.3,2313.3,1178.4,2130.2,972.6,2153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M725.3,2390.1c-14.5,49.7-18.9,92-20.1,108c-0.4,6.2,2.2,12.5,7.5,15.9c6.7,4.2,13.4,1.6,18.1-1.5 c3.1-2,5.6-4.7,7.8-7.7c6-8.5,12.3-16.6,18.8-24.2c112.4-350.2,413.1-223.2,435.4-213.2 C916.2,2133.2,783.7,2276.3,725.3,2390.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M250.9,2152.7c347.2,82.5,448.8,288.4,448.8,288.4C582.7,2199.3,250.9,2152.7,250.9,2152.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M292.9,2104.5c-2.4-1.8-5.9,0.3-5.3,3.3c5.1,30.3,18.8,38.1,25.2,40.1c1.9,0.6,3.9-0.6,4.3-2.6 C318.2,2138.6,317.5,2122.9,292.9,2104.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M331.4,2114.5c-2.3-2-5.9-0.2-5.6,2.8c2.7,30.7,15.7,39.4,21.9,41.9c1.9,0.7,4-0.3,4.5-2.3 C353.9,2150.5,354.5,2134.8,331.4,2114.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M369.3,2133.3c-2.1,27.4,8,37.1,13.1,40.2c1.5,0.9,3.6,0.3,4.3-1.3c2.4-5.4,5.3-19.2-12.1-40.5 C373,2129.6,369.5,2130.6,369.3,2133.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M409.3,2146.1c-7.5,26.4,0.5,37.9,4.9,42c1.3,1.2,3.4,1,4.5-0.5c3.5-4.8,9-17.7-3.8-42.1 C413.6,2143.2,410,2143.5,409.3,2146.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M447.8,2162.1c-10.8,23.5-5,35.3-1.5,39.7c1.1,1.3,3,1.4,4.2,0.2c3.9-4,10.9-15.2,2.5-39.7 C452.3,2160,448.9,2159.8,447.8,2162.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M494.8,2173.2c-21.3,14.7-22.4,27.8-21.6,33.4c0.2,1.7,1.9,2.8,3.5,2.3c5.4-1.4,17.2-7.5,22.5-32.8 C499.7,2173.7,496.9,2171.8,494.8,2173.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M293.4,2178c-6.3-2.3-21.8-4.5-44.4,16.4c-2.2,2.1-0.8,5.8,2.2,5.9c30.8,0.4,40.9-11.6,44-17.6 C296.1,2180.9,295.3,2178.7,293.4,2178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M328.2,2190.3c-6.4-1.8-22.1-2.8-43,19.8c-2.1,2.2-0.3,5.9,2.7,5.7c30.7-2,39.9-14.8,42.5-21 C331.2,2193,330.1,2190.9,328.2,2190.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M364.4,2200.2c-5.9-0.7-19.9,0.8-34.9,23.9c-1.5,2.3,0.6,5.2,3.2,4.6c26.8-6.3,32.9-19,34.3-24.8 C367.4,2202.2,366.2,2200.4,364.4,2200.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M398.5,2208.1c-5.9,0.5-19.3,4.7-29.5,30.3c-1,2.5,1.6,5,4.1,3.9c25-11.5,28.5-25.1,28.7-31 C401.8,2209.4,400.3,2207.9,398.5,2208.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M426.9,2223.2c-5.5,2.3-17,10.4-19,37.8c-0.2,2.7,3,4.3,5,2.4c20.4-18.5,19.6-32.5,18-38.3 C430.5,2223.4,428.6,2222.5,426.9,2223.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M461.6,2237c-5.3,2.8-16,11.9-15.3,39.4c0.1,2.7,3.4,4,5.2,2c18.5-20.4,16.4-34.2,14.3-39.8 C465.1,2236.9,463.2,2236.2,461.6,2237z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M733.1,2453.3c0,0,29.7-291.4,408.1-544.8C1141.3,1908.6,765.3,2112.1,733.1,2453.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1069.6,1869.6c-21.2,33-15,52.1-10.7,59.4c1.3,2.2,4.3,2.8,6.3,1.2c6.7-5.2,19.6-20.5,12.2-59.1 C1076.7,1867.3,1071.7,1866.3,1069.6,1869.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1028,1898.7c-18.6,34.6-10.9,53.1-6,60.1c1.5,2.1,4.5,2.4,6.4,0.7c6.3-5.7,18-22,7.6-59.9 C1034.9,1895.9,1029.8,1895.3,1028,1898.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M983.9,1938.5c-11.2,33.2-1.7,48.4,3.6,53.8c1.6,1.6,4.3,1.5,5.7-0.3c4.7-6,12.6-22.1-2.2-53.9 C989.6,1935,985,1935.2,983.9,1938.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M942,1973c-4.5,34.8,7.9,47.8,14.2,52c1.9,1.3,4.5,0.6,5.5-1.4c3.4-6.8,7.9-24.1-12.8-52.4 C946.9,1968.4,942.5,1969.6,942,1973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M903.8,2010.2c0.9,33,14.2,43.3,20.7,46.3c2,0.9,4.3-0.1,5-2.1c2.2-6.8,3.9-23.6-19.5-46.8 C907.7,2005.2,903.8,2006.9,903.8,2010.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M858.8,2041.7c-3.2-0.8-5.7,2.7-3.9,5.4c17.6,27.9,34.4,29.9,41.5,29.2c2.1-0.2,3.6-2.3,3.2-4.4 C898,2065,890.8,2049.8,858.8,2041.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1162.2,1957.5c-36.4-15-54-5.4-60.4,0.2c-1.9,1.7-2,4.7-0.1,6.4c6.3,5.7,23.8,15.6,60.4,1.4 C1165.7,1964.1,1165.8,1959,1162.2,1957.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1125.9,1992.5c-35.1-17.8-53.4-9.6-60.3-4.6c-2.1,1.5-2.3,4.5-0.6,6.4c5.9,6.2,22.5,17.4,60.1,6.1 C1128.9,1999.4,1129.4,1994.3,1125.9,1992.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1079.1,2028.9c-28.2-20.9-45.6-16.4-52.4-13c-2.1,1-2.7,3.6-1.5,5.6c4.2,6.3,17.2,18.7,52,14.3 C1080.8,2035.4,1081.9,2030.9,1079.1,2028.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M989.4,2040.5c-2.2,0.6-3.4,3-2.5,5.2c2.9,7,13.2,21.7,48.2,24.3c3.5,0.3,5.5-3.8,3.1-6.4 C1014.7,2037.5,996.8,2038.4,989.4,2040.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M962.2,2071.2c-2.3-0.1-4.2,1.9-4,4.2c0.7,7.6,6,24.7,38.6,37.8c3.2,1.3,6.4-2,4.9-5.2 C987.2,2076,969.8,2071.5,962.2,2071.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M927,2103.2c-2.3-0.3-4.3,1.5-4.3,3.8c-0.1,7.6,3.6,25.1,34.8,41.2c3.1,1.6,6.5-1.4,5.4-4.7 C951.3,2110.3,934.5,2104.2,927,2103.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M692.9,2648.8c151.7-514.2-275.9-1028.4-275.9-1028.4C819.2,2208.4,692.9,2648.8,692.9,2648.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M531.4,1603.1c-33.2,51.7-23.4,81.5-16.6,92.9c2,3.5,6.7,4.4,9.9,1.9c10.5-8.1,30.7-32.2,19-92.5 C542.5,1599.5,534.7,1598,531.4,1603.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M575.1,1668.7c-37.1,49-29.7,79.4-23.8,91.4c1.8,3.6,6.3,4.9,9.7,2.7c11.1-7.3,33.1-29.7,26.2-90.7 C586.5,1666,578.8,1663.9,575.1,1668.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M617.9,1750.7c-39.9,37.6-37.9,65.5-34.5,76.9c1,3.4,4.8,5.2,8.1,3.8c10.9-4.8,33.5-21.2,36.5-76 C628.3,1750,621.9,1747,617.9,1750.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M659.8,1823.2c-46.6,29-50.1,56.7-49.1,68.6c0.3,3.6,3.7,6.1,7.2,5.3c11.6-2.5,37.1-14.2,50.8-67.3 C670.1,1824.6,664.4,1820.4,659.8,1823.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M695.2,1898.6c-47.5,20.2-54.8,45.5-55.5,56.7c-0.2,3.4,2.6,6.2,5.9,6c11.2-0.7,36.5-7.8,57-55.2 C704.7,1901.3,699.9,1896.6,695.2,1898.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M749.7,1978c-51.2-6.9-70.4,11.1-76.7,20.3c-1.9,2.8-1,6.6,2.1,8.2c9.9,5.1,35.4,12,77.2-18.3 C756.4,1985.2,754.7,1978.7,749.7,1978z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M358.1,1679.3c-6.1,0.1-9,7.5-4.5,11.7c44.9,42,76,37.7,88.5,33.1c3.8-1.4,5.5-5.8,3.6-9.4 C439.6,1702.9,419.6,1678.7,358.1,1679.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M390.5,1751.3c-6.1,0.5-8.4,8.2-3.6,12c48.1,38.3,78.8,31.6,90.9,26c3.7-1.7,5-6.2,2.9-9.6 C473.6,1768.4,451.7,1745.9,390.5,1751.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M437.2,1831.2c-5.3,1.4-6.2,8.5-1.4,11.1c48,26.6,74.1,16.2,83.9,9.5c3-2,3.5-6.2,1.1-8.9 C513,1834,490.4,1817.4,437.2,1831.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M560.7,1900.2c-9.5-7.2-34.9-19-84.3,5.1c-4.9,2.4-4.4,9.5,0.8,11.2c52.4,16.6,75.8,1.2,84.1-7.3 C563.9,1906.6,563.6,1902.4,560.7,1900.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M582.4,1960.7c-11.2-4-39-7.5-78.8,30.4c-3.9,3.8-1.3,10.4,4.2,10.4c54.9,0,72.6-21.8,78-32.4 C587.3,1965.9,585.7,1961.9,582.4,1960.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M615,2027.7c-11.5-2.9-39.6-3.8-75.6,37.7c-3.6,4.1-0.3,10.5,5.1,9.9c54.7-5.2,70.2-28.6,74.5-39.6 C620.4,2032.3,618.5,2028.5,615,2027.7z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M860.1,2430.8H586.8c-14,0-25.3,11.3-25.3,25.3v425.2c0,14,11.3,25.3,25.3,25.3h273.3 c14,0,25.3-11.3,25.3-25.3v-425.2C885.3,2442.1,874,2430.8,860.1,2430.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M860.1,2430.8h-29.7c-2.6,97.2-31.3,368.4-268.9,434.9v15.6c0,14,11.3,25.3,25.3,25.3h273.3 c14,0,25.3-11.3,25.3-25.3v-425.2C885.3,2442.1,874,2430.8,860.1,2430.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091001250587350180080000000591350891734165402_)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1651.8,3154h-24.3v-335.3c0-19.6-8.1-38.5-22.3-51.9l-35.7-33.8c-19-18-29.9-43.4-29.9-69.5V1942h24.3 v721.4c0,19.6,8.1,38.5,22.3,51.9l35.7,33.8c19,18,29.9,43.4,29.9,69.5V3154z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1557.8,2452.7l-12.1-21l154.3-88.5c12.9-7.4,20.8-21.1,20.8-36v-387.3h24.3v387.3 c0,23.5-12.7,45.3-33,57L1557.8,2452.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1544.8,2641.8l-107.5-74.9c-26.6-18.5-42.5-49-42.5-81.4v-381.3h24.3v381.3c0,24.5,12,47.5,32.1,61.5 l107.5,74.9L1544.8,2641.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2092.3,2630.2l-142.8-182.4c-15-19.1-23.2-43-23.2-67.3v-431.9h24.3v431.9c0,18.9,6.4,37.5,18,52.3 l142.8,182.4L2092.3,2630.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2089.7,
    y: 1903.2,
    className: "st22",
    width: 24.3,
    height: 1197.4
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2109.8,2708.6l-15.8-18.4l157.5-135.8c18.2-15.7,28.7-38.5,28.7-62.6v-489.1h24.3v489.1 c0,31.1-13.5,60.6-37.1,81L2109.8,2708.6z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2296.5,2272.1l-8.4-22.7l86.7-32.2c20.3-7.5,34-27.2,34-48.8v-259.5h24.3v259.5 c0,31.8-20,60.5-49.8,71.6L2296.5,2272.1z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2601.9,
    y: 1919.9,
    className: "st22",
    width: 24.3,
    height: 1056.3
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2621,2468.6l-13.9-19.9l122.6-85.8c19.9-13.9,31.8-36.8,31.8-61.1v-398.6h24.3v398.6 c0,32.2-15.8,62.5-42.2,80.9L2621,2468.6z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1071.2262 1609.245)",
    className: "st22",
    cx: 1406.9,
    cy: 2097.7,
    rx: 40.3,
    ry: 40.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 1551.7,
    cy: 1942,
    r: 40.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 1733,
    cy: 1919.9,
    r: 40.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -599.8039 890.4593)",
    className: "st22",
    cx: 1938.4,
    cy: 1952.9,
    rx: 40.3,
    ry: 40.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8507 -0.5257 0.5257 0.8507 -689.6161 1390.0852)",
    className: "st22",
    cx: 2101.8,
    cy: 1908.8,
    rx: 40.3,
    ry: 40.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.982 -0.1891 0.1891 0.982 -337.3738 469.6168)",
    className: "st22",
    cx: 2292.2,
    cy: 2002.7,
    rx: 40.3,
    ry: 40.3
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -547.6691 1072.0084)",
    className: "st22",
    cx: 2420.8,
    cy: 1912.7,
    rx: 40.3,
    ry: 40.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9903 -0.1387 0.1387 0.9903 -241.027 381.1243)",
    className: "st22",
    cx: 2614,
    cy: 1919.9,
    rx: 40.3,
    ry: 40.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -46.1323 3737.3665)",
    className: "st22",
    cx: 2773.6,
    cy: 1903.2,
    rx: 40.3,
    ry: 40.3
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M875.7,464.2c-21.3,0-41.7,4.2-60.3,11.8C718,319.8,489.8,351.5,435.4,522.9 C368.6,523.1,314,575,309.4,640.7c231.3,0,493.6,0,725.2,0C1044.4,545.8,970.2,464.4,875.7,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3155.8,195.6c-66.8-211.8-351.1-255.4-474.4-58.6c-23.2-9.5-48.7-14.7-75.3-14.7 c-117.5-0.4-211.3,103.4-198.4,220.4c289.1,0,616.5,0,905.5,0C3307.5,260.7,3239.3,195.9,3155.8,195.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M3907.7,877.2c-0.1,0-0.2-0.1-0.3-0.1c-0.8-0.2-1.5-0.4-2.3-0.7c0,0-0.1,0-0.1,0 c-68.1-20.1-132.3-47.5-171.1-76.4c-50.1-37.3-66.8-75.6-77.3-93.9c-3.9-6.8-11.1-11-19-11h-76.1l83,129.5l72.8,50.1l97,15.1 h20.7L3615.4,1110l-53.7,408.4h68.7c15.4,0,30.9-4.3,42.5-14.5c207.2-181,269.1-438.6,280.8-555.7c0,0,0,0,0,0 c0.3-3.5,0.7-6.8,0.9-10C3955.8,895.7,3918.2,880.6,3907.7,877.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3819.1,884.1c-136.4-20.4-203.2-110-234.3-175.1c-9.9-20.8-39.4-20.8-49.4,0 c-31.1,65.1-97.9,154.6-234.3,175.1c-36.2,5.4-62.4,37.5-60.1,74c6.6,107,49.9,322.1,270,540.1c27.2,26.9,71,26.9,98.2,0 c220.1-218,263.5-433.2,270-540.1C3881.5,921.6,3855.4,889.5,3819.1,884.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3814,918.4c-133.7-20-206.9-101.5-244.1-163.9c-2.2-3.7-6-5.5-9.7-5.5s-7.5,1.8-9.7,5.5 c-37.2,62.4-110.4,143.9-244.1,163.9c-18.6,2.8-31.8,19-30.7,37.6c6.4,103.5,48.6,308.4,259.8,517.6 c6.6,6.5,15.4,10.2,24.7,10.2s18.1-3.6,24.7-10.2c211.3-209.3,253.5-414.1,259.8-517.6C3845.8,937.4,3832.6,921.2,3814,918.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3550.4,754.5c-37.2,62.4-110.4,143.9-244.1,163.9c-18.6,2.8-31.8,19-30.7,37.6 c6.4,103.5,48.6,308.4,259.8,517.6c6.6,6.5,15.4,10.2,24.7,10.2V749C3556.3,749,3552.6,750.8,3550.4,754.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M3669.7,1087.4H3659v-58.5c0-26.9-10.9-51.2-28.5-68.9c-17.6-17.6-42-28.5-68.9-28.5 c-53.8,0-97.4,43.6-97.4,97.4v58.5h-3.7c-17.4,0-31.5,14.1-31.5,31.5V1260c0,17.4,14.1,31.5,31.5,31.5h209.2 c17.4,0,31.5-14.1,31.5-31.5v-141.1C3701.2,1101.5,3687.1,1087.4,3669.7,1087.4z M3621.1,1087.4h-118.9v-58.5 c0-32.8,26.7-59.5,59.5-59.5s59.5,26.7,59.5,59.5V1087.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3561.6,1141.1c-14.7,0-26.7,11.9-26.7,26.7c0,11.8,7.6,21.8,18.2,25.3v45.3c0,4.7,3.8,8.4,8.4,8.4 s8.4-3.8,8.4-8.4V1193c10.6-3.5,18.2-13.5,18.2-25.3C3588.3,1153,3576.3,1141.1,3561.6,1141.1z"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2888.6,873c-16.4,102.3-65.5,238.3-65.5,238.3l58.3,49.4l32.4,5.9l18.5-89.3l25.3-329.6 C2957.6,747.6,2905,770.7,2888.6,873z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "3266.8,2791.8 3280.8,2904.8 3272.9,2927.5 3235.1,3036.4 3219.2,3082.1 3448.8,3084.5  3616.9,2776.6 3298.1,2622.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M3290.9,2928.1c-6.1,0-12.1,0.3-18,1c-62.5,7.1-113.9,50.6-132.5,108.8c-4.8,15.2-7.5,31.3-7.5,48.1 h315.9c0-26.4-6.5-51.3-18-73.2C3404.5,2962.5,3351.7,2928.1,3290.9,2928.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M3430.9,3012.9L3430.9,3012.9c-8.8,15.5-25.3,25.1-43.2,25.1h-247.3c-4.8,15.2-7.5,31.3-7.5,48.1h315.9 l168.1-309.5l-48.6-23.5L3430.9,3012.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M3307.8,2222.5c-9.4-43.1-25.2-118.4-39-198.2c-17.5-101.3-31.8-210.1-25.8-269.3l-265.6-112.1l-6.6-2.8 l-47.7-20.1l-49.1,82.7l224.2,613.1l133.6,576.7c0,0,267.2,43.2,299.5-185.2L3332,2292.9 C3321.3,2270.5,3313.1,2246.9,3307.8,2222.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3163.6,2430.5c-12.1-127.7,64.8-316.1,105.3-406.3c-17.5-101.4-31.8-210.1-25.8-269.3l-319.9-135.1 l-49.1,82.7l224.2,613.1l133.6,576.7c0,0,267.2,43.2,299.5-185.2C3323.7,2867.7,3179.8,2602.6,3163.6,2430.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3078.5,1924.1 3090.3,1955.2 3096.5,1952.9 3084.7,1921.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3102,1986.2 3113.8,2017.3 3120,2015 3108.3,1983.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3054.9,1862 3066.7,1893.1 3073,1890.7 3061.2,1859.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3149.1,2110.4 3160.9,2141.5 3167.1,2139.2 3155.3,2108.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3125.6,2048.3 3137.3,2079.4 3143.6,2077.1 3131.8,2046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2972.5,1644.7 2977.4,1642.9 2970.8,1640  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2984.3,1675.7 2996.1,1706.8 3002.4,1704.4 2990.6,1673.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3031.4,1799.9 3043.1,1831 3049.4,1828.6 3037.7,1797.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3172.6,2172.5 3184.4,2203.6 3190.6,2201.3 3178.9,2170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3007.8,1737.8 3019.6,1768.9 3025.9,1766.5 3014.1,1735.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3412,2719.1 3426.1,2749.2 3432.2,2746.4 3418.1,2716.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3384,2659 3398,2689 3404.1,2686.2 3390,2656.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3355.9,2598.7 3369.9,2628.9 3376,2626 3362,2595.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3440.1,2779.4 3454.2,2809.4 3460.2,2806.6 3446.2,2776.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3334.6,
    y: 2535.6,
    transform: "matrix(0.9062 -0.4229 0.4229 0.9062 -766.1362 1651.0028)",
    className: "st3",
    width: 6.6,
    height: 33.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3278.4,
    y: 2415.2,
    transform: "matrix(0.9062 -0.4229 0.4229 0.9062 -720.4822 1615.931)",
    className: "st3",
    width: 6.6,
    height: 33.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3215.6,2297.8 3229.6,2327.9 3235.7,2325 3221.6,2294.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3243.6,2358 3257.7,2388.1 3263.7,2385.3 3249.7,2355.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3299.8,2478.4 3313.8,2508.5 3319.9,2505.7 3305.8,2475.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3191,2235.4c2.2,9.4,5.7,19.9,10.8,32l6.2-2.5c-4.9-11.8-8.3-21.9-10.5-31L3191,2235.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M3154.1,2853.6l-260.6,58.1l-64.2,18.1c-64.7,18.3-118.5,57.9-162.1,108.2c-12.6,14.5-24.3,29.9-35.3,46 c-0.2,0.3-0.4,0.4-0.6,0.4h551.2l-5.7-46.4L3154.1,2853.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2829.2,2931.4c-64.7,18.3-118.5,57.9-162.1,108.2c-12.6,14.5-24.3,29.9-35.3,46 c-0.2,0.3-0.4,0.4-0.6,0.4h245.9C2936.2,2968.4,2829.2,2931.4,2829.2,2931.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2667.2,3039.7c-12.6,14.5-24.3,29.9-35.3,46c-0.2,0.3-0.4,0.4-0.6,0.4h551.2l-5.7-46.4H2667.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M3252.3,1660.8l-7.5,0.2l-200.1,6.3l-174.9,463c-5.9,15.6-9.1,32.1-9.6,48.7l-18.9,704.3 c58.9,39.4,114.8,53.7,163.5,54.7c2.3,0.1,4.5,0.1,6.7,0.1c99.8-0.3,168.1-54.8,168.1-54.8l-75.7-610.6 c-2.7-21.9,1.6-44.1,12.3-63.3l108.8-195.3c28.7-51.5,60.9-100.9,98.6-146.1c97.1-116.6,43.7-210.7,43.7-210.7L3252.3,1660.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3003.8,2588.2 2997.2,2588.4 2997.9,2621.9 3004.6,2621.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3009.7,2856.2 3003,2856.4 3003.8,2889.9 3010.5,2889.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3005.3,2655.2 2998.6,2655.3 2999.4,2688.8 3006,2688.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3006.8,2722.2 3000.1,2722.3 3000.8,2755.9 3007.5,2755.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3002.4,2521.2 2995.7,2521.3 2996.5,2554.8 3003.2,2554.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3006.4,2188.4l-6.4-2.3c-3.8,10.8-6.6,21.9-8.4,33.1l6.6,1C3000,2209.4,3002.7,2198.7,3006.4,2188.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2996.5,2253.1 2989.9,2253.3 2990.6,2286.8 2997.3,2286.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3001,2454.2 2994.3,2454.3 2995,2487.8 3001.7,2487.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2998,2320.1 2991.3,2320.3 2992.1,2353.8 2998.8,2353.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2999.5,2387.1 2992.8,2387.3 2993.5,2420.8 3000.2,2420.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3008.2,2789.3 3001.6,2789.4 3002.3,2822.9 3009,2822.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3127.3,1912.4 3133.3,1915.2 3147.6,1884.9 3141.5,1882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3155.7,1851.6 3161.7,1854.5 3175.9,1824.1 3169.9,1821.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3184.1,1790.9 3190.2,1793.7 3204.3,1763.4 3198.2,1760.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3240.8,1669.5 3246.9,1672.3 3252.3,1660.8 3244.8,1661  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3212.5,1730.2 3218.5,1733 3232.7,1702.7 3226.7,1699.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3098.9,1973.1 3105,1975.9 3119.2,1945.6 3113.1,1942.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3013.7,2155.3 3019.8,2158.1 3034,2127.7 3028,2124.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3042.1,2094.5 3048.2,2097.4 3062.4,2067 3056.3,2064.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3070.6,2033.8 3076.6,2036.7 3090.7,2006.3 3084.7,2003.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3004.5,2923.4l0.3,14.6c2.3,0.1,4.5,0.1,6.7,0.1l-0.3-14.8L3004.5,2923.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3060.9,692.2l-105,218.6l-62.1,483.5l-6.8,53.1l-13,101.8l220.5,43.2l15.9-308.4l3.2-61.8l12.1-235.8 l53-289.2C3178.8,697.2,3091.4,750.2,3060.9,692.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M2893.9,1394.3l-6.8,53.1l-13,101.8l220.5,43.2l15.9-308.4C3110.5,1284,3019.8,1421.7,2893.9,1394.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M2918.1,836.7c-0.1,70.8-28.9,198.7-62.5,389.4c-59.3,336.2-41.5,443.3-41.5,443.3l47.5,24.6 c17.6,9.1,38.6-3.5,38.9-23.2c9.5-622.4,160.5-978.5,160.5-978.5l-69.9,34C2946.8,745.1,2918.1,788.5,2918.1,836.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M3034.9,714.9c-10.7,12.2-21.3,24.4-32,36.6c-10.3,11.8-28.3,26.6-28.9,43.4c-0.3,7.3,2,15.2,3.3,22.3 c1.6,8.9,5.5,20.1,1.1,28.7c-2.3,4.6-6.6,8.5-9.9,12.4c-6.1,7.1-12.1,14.1-18.2,21.2c-9,10.4-20,20.7-27.4,32.3 c-6.2,9.6-4.8,20.5-4.5,31.3c1.6,60.9,3.3,121.7,4.9,182.6c0.2,7.2,11.4,7.2,11.2,0c-0.8-29.1-1.6-58.1-2.4-87.2 c-0.9-33.5-1.8-67-2.7-100.5c-0.3-9.6,0.2-17.3,6.9-25.2c11.4-13.2,22.7-26.5,34.1-39.7c10.2-11.9,23-23.2,20.9-40.5 c-1.8-14.6-11.6-36.1-1.6-49.1c16.3-21.2,35.5-40.6,53.1-60.8C3047.5,717.4,3039.6,709.5,3034.9,714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M3318.4,1338.8c-16.8-67.6-28.7-118.7-28.7-118.7l4.3-48.7l3.8-43.1l29.1-328.6l-148.1-102.4 c-84.5,206.3-124.9,439.8-143.8,631.9c-2.2,21.5-3.9,42.5-5.6,62.8c-6.6,82.2-9.2,154.4-10.1,210.4 c-1.2,75.9,0.8,121.7,0.8,121.7c8.5,2.9,16.8,5.6,25,8c261.5,77.9,371.6-67.1,371.6-67.1c-19.1-21.4-60.6-174.8-91-295.7 C3323.3,1358.8,3320.7,1348.6,3318.4,1338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M3195.9,726.8c-1-7.1-11.7-4.1-10.8,3c2.2,15.8,4.3,31.7,6.5,47.5c1.5,10.6,2.9,21.2,4.4,31.8 c0.8,6.1,2.8,13.2,1.6,19.3c-2.1,11.1-14.5,16.6-23,22.3c-9.1,6-16.2,13.6-17.2,25.1c-0.5,6.1,1.1,12,2.4,17.9 c2,8.9,3.9,17.7,5.9,26.6c3.1,13.9,7.1,27.9,9.3,42c1.7,11-6.8,21.1-12.3,30c-32.7,53.4-65.5,106.8-98.2,160.2 c-3.8,6.2,5.9,11.8,9.6,5.6c16.2-26.5,32.4-52.9,48.7-79.4c18.3-29.9,36.7-59.8,55-89.8c6.2-10.1,10-19.2,7.5-31.6 c-3.5-17.2-7.6-34.3-11.4-51.4c-1.6-7.2-3.4-14.3-4.8-21.6c-2-10.7,2.3-18.2,11-24c7.4-4.9,16.5-9.5,22.2-16.5 c6.1-7.6,7.2-16.5,6-25.8C3204.5,787.6,3200.1,757.2,3195.9,726.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M3224.1,894.6c0,0,6.3,310-189.1,434.5c-2.2,21.5-3.9,42.5-5.6,62.8l6.4,6.6l258.1-227.2l13.6-12 l-9.8-31.1L3224.1,894.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M3189.9,1394l-170.5,208.3c-1.2,75.9,0.8,121.7,0.8,121.7c8.5,2.9,16.8,5.6,25,8 c196.5-42.9,280.7-362.8,280.7-362.8c-2.6-10.4-5.2-20.6-7.6-30.4L3189.9,1394z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M3189.7,477l-101-150.6l-120.8,39.8l-13.3,122.4c0,0,4.6,180,100.4,174.1l5,48.7 c2.4,23.8,25.1,40.5,48.4,35c18.4-4.3,37.4-15,70.4-49.3c-1.2-34.2,10.8-87.4,13.2-104.6c0.5-3.8,3-6.9,6.5-8.2 c5.1-1.9,13.3-5.3,22.1-10.4c2.9-1.6,5.9-3.5,8.8-5.5c0.1,0,0.1-0.1,0.2-0.1c19-13.1,37-33.8,30.2-63.5 C3245.5,441.9,3189.7,477,3189.7,477z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3055,668.2l2,19.8c59-17.5,55.1-57.1,55.1-57.1C3092,664,3063.5,667.7,3055,668.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3218.6,498.1c-7.6-4.4-16.8,3.5-13.7,11.7c0,0.1,0.1,0.2,0.1,0.3c4.6,11.4-4.8,16-6.1,26.4 c-1.3,10.4,17.5,25.1,26.6-9.1C3230.3,509.7,3224.9,501.7,3218.6,498.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3084.3,472.3c-4.5-3.3-10-5.3-15.6-5.7c-10.4-0.7-20.8,5.9-23.6,16.1c-1.7,6.2,8,8.9,9.7,2.7 c0.7-2.7,2.4-5,4.8-6.5c2.8-1.8,5.6-2.5,9.1-2.2c6.2,0.5,14.5,5.2,15.4,11.7c0.4,2.7,3.8,4.2,6.2,3.5c2.9-0.8,3.9-3.5,3.5-6.2 C3093,480,3088.8,475.6,3084.3,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2984.9,462.7c-9.7,0.5-20.5,7.4-23.2,17c-0.7,2.6,0.9,5.5,3.5,6.2c2.6,0.7,5.4-0.9,6.2-3.5 c1.5-5.2,8.8-9.6,14.2-9.7c6.2-0.1,11.3,5.8,14.1,11.5c1.2,2.4,4.7,3.1,6.9,1.8c2.5-1.5,3-4.4,1.8-6.9 C3004,470.4,2995.2,462.2,2984.9,462.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2985.2,498.9c-4.9,0-8.9,6.4-8.9,14.3c0,7.9,4,14.3,8.9,14.3s8.9-6.4,8.9-14.3 C2994.1,505.3,2990.1,498.9,2985.2,498.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3067.1,498.1c-5.2,0-9.4,6.7-9.4,15c0,8.3,4.2,15,9.4,15c5.2,0,9.4-6.7,9.4-15 C3076.5,504.8,3072.3,498.1,3067.1,498.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3065,575.3l-58.6,7.7c-3.4,0.4-5.7,3.8-4.7,7.1c3.3,11.6,13.1,35.1,37.8,33.5c24.8-1.6,30.6-29,31.9-42.2 C3071.7,577.8,3068.6,574.8,3065,575.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3173.7,566.1c3.4,20.1,24.9,18.3,24.9,18.3c5.1-1.9,13.3-5.3,22.1-10.4 C3190.7,586.8,3175.1,567.9,3173.7,566.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3131.8,308.5l-110.9,6.2l-57.5,49.3l11.8,102.6c13.2-54.8,18.9-64.3,18.9-64.3 c19.8-42.4,36.4,5.5,36.4,5.5c-1.4-8.7,11-33.9,17.8-14.6c8.5,24.3,38.4,60.2,38.4,60.2c57.6,68.7,100.2,28.7,100.2,28.7 l43.5-67.1l-48.8-64.4L3131.8,308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3268.2,261.7c-12.5,4.9-14.4,33.4-14.7,44.7c0,1.8,2.1,2.8,3.5,1.6 C3285.8,282.6,3283.3,255.7,3268.2,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3296.4,305c-7.9-5.8-26.4,4.1-33.4,8.3c-1.1,0.7-0.9,2.4,0.4,2.8C3290.4,324,3306,312,3296.4,305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3250.2,322.7c0,0-9.7-58.9-86-77.7c-76.2-18.8-133.7,33.9-133.7,33.9c-66.6-42-98.4,52.2-98.4,52.2 c-39.5,26.1-14.6,55.8-17.9,103.9c-0.6,9.7-0.7,19.2-0.2,27.8c2.3,34.3,14.6,57.1,40.7,40.2c32.7-21.2,16.2-81.1,39-113.7 c22.9-32.6,33.9,0,33.9,0c2.4-7.9,6.1-12.4,10-14.7c8.5-5.1,19.1,1,20.9,10.8c10,54,91.1,124,131,95.2 c42.4-30.6,60.9,3.4,60.9,3.4c3.4-4.9,6.5-9.7,9.3-14.4C3328.1,357.5,3250.2,322.7,3250.2,322.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3179,457.5c-28.9,16.9-92.4-25.3-109.6-76.4c-17.2-51.1-43.6-9.8-43.6-9.8c-55-60.3-52,87.9-74.7,111.5 c-22.6,23.5-37.1-20.1-37.1-20.1s0,0-0.1,0.1c2.3,34.3,14.6,57.1,40.7,40.2c32.7-21.2,16.2-81.1,39-113.7 c22.9-32.6,33.9,0,33.9,0c2.4-7.9,6.1-12.4,10-14.7c8.5-5.1,19.1,1,20.9,10.8c10,54,91.1,124,131,95.2 c42.4-30.6,60.9,3.4,60.9,3.4c3.4-4.9,6.5-9.7,9.3-14.4c-0.6-1-1-2.1-1.4-3C3250.5,447.7,3207.9,440.7,3179,457.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3093.9,346.7c0,0,19.7,87.5,113,85.4C3206.9,432.1,3139.4,410.9,3093.9,346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3251.9,342.7c19.4,40.8,4.4,94.2,4.4,94.2C3289.3,367.5,3251.9,342.7,3251.9,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2944.9,335.1c0,0,21.7-48.5,80.6-41.9C3025.5,293.2,2973.7,258.8,2944.9,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3067.1,282c0,0,102.5-24.4,165.7,36.7C3232.7,318.7,3182.2,234.2,3067.1,282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2946.5,1065.4h-816.8c-28.1,0-50.9,22.8-50.9,50.9v501.1c0,28.1,22.8,50.9,50.9,50.9h816.8 c28.1,0,50.9-22.8,50.9-50.9v-501.1C2997.4,1088.2,2974.6,1065.4,2946.5,1065.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2946.5,1638.8h-816.8c-11.9,0-21.5-9.6-21.5-21.5v-501.1c0-11.9,9.6-21.5,21.5-21.5h816.8 c11.9,0,21.5,9.6,21.5,21.5v501.1C2968,1629.2,2958.4,1638.8,2946.5,1638.8z M2129.7,1112.6c-2,0-3.6,1.6-3.6,3.6v501.1 c0,2,1.6,3.6,3.6,3.6h816.8c2,0,3.6-1.6,3.6-3.6v-501.1c0-2-1.6-3.6-3.6-3.6H2129.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2365.1,1296.7c-16-14.8-38.6-22.2-67.7-22.2h-47.3c-13.1,0-19.7,6.6-19.7,19.7v131.8 c0,13.1,6.6,19.7,19.7,19.7h47.3c29.1,0,51.7-7.4,67.7-22.3c16-14.9,24-36,24-63.3C2389.1,1332.6,2381.1,1311.5,2365.1,1296.7z  M2295.2,1414.8H2268v-109.5h27.2c36.4,0,54.6,18.2,54.6,54.6C2349.8,1396.5,2331.6,1414.8,2295.2,1414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2509.8,1288.1c-2.4-5.5-5.4-9.5-9-12c-3.6-2.5-7.7-3.8-12.4-3.8c-4.7,0-8.8,1.3-12.4,3.8 c-3.6,2.5-6.6,6.5-9.2,12l-62.1,136.1c-3.1,6.6-3.2,12.2-0.2,16.7c2.9,4.5,7.8,6.8,14.6,6.8c5,0,8.9-1.3,11.6-3.8 c2.7-2.5,5.3-6.6,7.8-12.3l10-23.3h79.8l10.2,23.3c2.3,5.5,4.9,9.5,7.9,12.1c3,2.6,7.2,3.9,12.7,3.9c6.3,0,10.9-2.2,13.7-6.7 c2.8-4.4,2.7-10.1-0.4-16.9L2509.8,1288.1z M2461,1379.1l26.9-64.6h0.5l27.4,64.6H2461z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2699,1274.5h-123.5c-10.5,0-15.8,5.2-15.8,15.5c0,10.4,5.3,15.5,15.8,15.5h43v122.8 c0,6.2,1.6,10.9,4.9,14.3c3.2,3.4,7.9,5.1,14.1,5.1c6.1,0,10.8-1.7,14-5.1c3.2-3.4,4.7-8.2,4.7-14.3v-122.8h43 c10.5,0,15.8-5.2,15.8-15.5C2714.8,1279.7,2709.6,1274.5,2699,1274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2807.5,1288.1c-2.4-5.5-5.4-9.5-9-12c-3.6-2.5-7.7-3.8-12.4-3.8c-4.7,0-8.8,1.3-12.4,3.8 c-3.6,2.5-6.6,6.5-9.2,12l-62.1,136.1c-3.1,6.6-3.2,12.2-0.2,16.7c2.9,4.5,7.8,6.8,14.6,6.8c5,0,8.9-1.3,11.6-3.8 c2.7-2.5,5.3-6.6,7.8-12.3l10-23.3h79.8l10.2,23.3c2.3,5.5,4.9,9.5,7.9,12.1c3,2.6,7.2,3.9,12.7,3.9c6.3,0,10.9-2.2,13.7-6.7 c2.8-4.4,2.7-10.1-0.4-16.9L2807.5,1288.1z M2758.7,1379.1l26.9-64.6h0.5l27.4,64.6H2758.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2598,895.9l-479.5,168.8c-5.9,2.1-9,8.5-6.9,14.4s8.5,9,14.4,6.9l479.5-168.8c5.9-2.1,9-8.5,6.9-14.4 C2610.3,896.9,2603.8,893.8,2598,895.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2958.3,1064.7l-344.2-121.1c-5.9-2.1-12.3,1-14.4,6.9c-2.1,5.9,1,12.3,6.9,14.4l344.2,121.1 c5.9,2.1,12.3-1,14.4-6.9C2967.3,1073.2,2964.2,1066.7,2958.3,1064.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M2923.6,1515.9c-16,4.6-30.6,12.9-42.8,24.3c-13.1,12.3-29.8,28.9-39.5,42.5c0,0,0,0,0,0 c-6.3,8.9-9.6,16.4-6.8,20.6c15.2,22.5,61.8-15.6,62.8-16.4c-0.8,1.3-55.1,85.4-125.2,81c-1.9-0.1-2.9,1.9-2.3,3.5 c0.2,0.6,0.6,1.1,1.2,1.5l21.3,12c9.2,5.2,19.1,9.2,29.3,11.7c39.4,9.8,137.3,26.8,186.3-31.1c62.3-73.4,62.7-82.5,62.7-82.5 l-117.9-75.6L2923.6,1515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2978.3,1442.1l-42.1,37.7c-6,5.4-4.9,15.1,2.1,19c27.9,15.4,86.9,58.5,112.3,156.5 c2,7.8,11.2,11.3,17.9,6.8l65.4-44C3134,1618,3047.8,1416.8,2978.3,1442.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M3328.3,804.1c-0.8-2.8-3.1-5-5.9-5.7c-84.8-22.9-97.3,85.4-98.3,96.2c-0.1,0.5-0.1,1,0,1.6 c1.6,13.8,20.3,192.6-32,284.3c-47.1,82.7-194.6,215.1-233.3,249.2c-4.4,3.9-3.7,11,1.3,13.9 c106.5,60.1,131.8,173.3,137.3,211.1c1,6.2,7.8,9.4,13.1,6.2c126.8-75.5,208.4-294.5,253-419.4c6.4-18.1,12.1-34.3,17-47.7 c10.7-29.1,11.8-71,7.7-116.7C3378.2,965,3336.5,829.9,3328.3,804.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M3388.2,1077.2c0,0-77.2,58.6-24.7,164.3h0.1c6.4-18.1,12.1-34.3,17-47.7 C3391.2,1164.7,3392.3,1122.8,3388.2,1077.2L3388.2,1077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2855,1601.9c-23.9,2.4-14-18.6-13.7-19.2c-6.3,8.9-9.6,16.4-6.8,20.6c15.2,22.5,61.8-15.6,62.8-16.4 c-0.8,1.3-55.1,85.4-125.2,81c-1.9-0.1-2.9,1.9-2.3,3.5l0,0c0,0,34.8,19.5,89.4-22.9c54.6-42.5,47.3-80.7,47.3-80.7 S2879.2,1599.4,2855,1601.9z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.5,
    y: 3086,
    className: "st1",
    width: 3899.4,
    height: 35.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedSuccess);
export default __webpack_public_path__ + "static/media/createdSuccess.9f27d094fa59162853662ce23cd5925c.svg";
export { ForwardRef as ReactComponent };